import { lory } from '@rsm/allfarblori';
import h from 'hyperscript';
import icon from 'components/_particles/icon/generate-icon';

export default class Slider {
  constructor($el) {
    this.$el = $el;
    this.$slides = this.$el.querySelectorAll('.slider__slide');
    this.$inner = this.$el.querySelector('.slider__inner');
    this.$slidesContainer = this.$el.querySelector('.slider__slides-wrap');

    // Don't init slider, if only one slide exists
    if (this.$slides.length === 1) {
      return;
    }

    this.$el.addEventListener('before.lory.init', () => {
      this.$slidesContainer.scrollLeft = 0;
      this.initControls();
    });

    this.$el.addEventListener('after.lory.init', () => {
      window.console.log('[Slider] Initialized', $el);
      this.$el.classList.add('slider--initialized');
      this.initAutoplay();
    });

    this.$el.addEventListener('after.lory.slide', () => {
      window.console.log('[Slider] Slide', $el);
      this.updateDots();
      this.updatePagination();
    });

    this.lory = lory(this.$el, {
      rewind: true,
      slideSpeed: 250,
      ease: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
      classNameFrame: 'slider__slides-wrap',
      classNameSlideContainer: 'slider__slides',
      classNamePrevCtrl: 'slider__arrow--prev',
      classNameNextCtrl: 'slider__arrow--next',
      classNameDisabledPrevCtrl: 'slider__arrow--disabled',
      classNameDisabledNextCtrl: 'slider__arrow--disabled',
    });

    this.$slidesContainer.addEventListener('focusin', (event) => {
      this.$slidesContainer.scrollLeft = 0;
      const $slide = event.target.closest('.slider__slide');
      const index = Array.prototype.indexOf.call(this.$slides, $slide);
      this.lory.slideTo(index);
    });
  }

  initControls() {
    this.$controlPrev = h(
      'button.slider__arrow.slider__arrow--prev',
      {
        type: 'button',
        tabIndex: '-1',
        title: 'Vorheriger Slide',
      },
      icon({
        icon: 'arrow-left-box',
        className: 'slider__arrow-icon',
      }),
      h('span.u-hidden-visually', 'Vorheriger Slide'),
    );

    this.$controlNext = h(
      'button.slider__arrow.slider__arrow--next',
      {
        type: 'button',
        tabIndex: '-1',
        title: 'Nächster Slide',
      },
      icon({
        icon: 'arrow-right-box',
        className: 'slider__arrow__icon',
      }),
      h('span.u-hidden-visually ', 'Nächster Slide'),
    );

    this.$dots = h(
      '.slider__dots',
      [...this.$slides].map((_, index) => h(
        `button.slider__dots__dot${index === 0 ? '.slider__dots__dot--active' : ''}`,
        {
          type: 'button',
          tabIndex: '-1',
          title: (index + 1),
          onclick: () => this.lory.slideTo(index),
        },
        h('span.u-hidden-visually', (index + 1)),
      )),
    );

    this.$pagination = h(
      '.slider__pagination',
      h('span.u-hidden-visually', 'Aktuelle Seite'),
      h('span.slider__pagination__current-page', '1'),
      '/',
      h('span.u-hidden-visually', 'Seitenanzahl'),
      h('span.slider__pagination__total-page-count', this.$slides.length),
    );

    this.$controlPlay = h(
      'button.slider__play-control',
      {
        type: 'button',
        title: 'Slides automatisch abspielen',
        attrs: {
          'aria-pressed': this.isAutoplay() ? 'true' : 'false',
        },
      }, icon({
        icon: 'play',
        className: 'slider__play-control__icon slider__play-control__icon--play',
      }), icon({
        icon: 'pause',
        className: 'slider__play-control__icon slider__play-control__icon--stop',
      }),
      h('span.u-hidden-visually', 'Slides automatisch abspielen'),
    );

    this.$controls = h('.slider__controls');
    this.$controls.appendChild(this.$controlPrev);
    this.$controls.appendChild(this.$controlPlay);
    this.$controls.appendChild(this.$pagination);
    this.$controls.appendChild(this.$dots);
    this.$controls.appendChild(this.$controlNext);

    this.$inner.appendChild(this.$controls);
  }

  isPlaying() {
    return (this.$el.getAttribute('data-playing') === 'true');
  }

  isAutoplay() {
    return (this.$el.getAttribute('data-autoplay') === 'true');
  }

  initAutoplay() {
    // Touch kill
    let hasTouched = false;

    // Init timer
    const timerInit = () => setInterval(() => this.lory.next(), 5000);
    let timer = this.isPlaying() ? timerInit() : false;

    // Kill timer if a mouse enters the slider
    this.$el.addEventListener('mouseover', () => {
      // this.$el.setAttribute('data-playing', 'false');
      clearInterval(timer);
    });

    // Restart timer if a mouse leaves the slider
    this.$el.addEventListener('mouseleave', () => {
      if (!hasTouched && this.isPlaying()) timer = timerInit();
    });

    // Kill the timer if at least on touch interaction happend
    this.$el.addEventListener('touchstart', function killOnTouchStart() {
      clearInterval(timer);
      this.$el.revomeEventListener('touchstart', killOnTouchStart);
      hasTouched = true;
    }, { passive: true });

    // Autoplay toggle button (play/pause)
    this.$controlPlay.addEventListener('click', () => {
      if (this.isPlaying()) {
        this.$controlPlay.setAttribute('aria-pressed', 'false');
        this.$el.setAttribute('data-playing', 'false');
        clearInterval(timer);
      } else {
        this.$controlPlay.setAttribute('aria-pressed', 'true');
        this.$el.setAttribute('data-playing', 'true');
        if (!hasTouched) timer = timerInit();
        setTimeout(() => this.lory.next(), 500);
      }
    });
  }

  updateDots() {
    this.$el.querySelector('.slider__dots__dot--active')
      .classList.remove('slider__dots__dot--active');

    this.$el.querySelectorAll('.slider__dots__dot')[this.lory.returnIndex()]
      .classList.add('slider__dots__dot--active');
  }

  updatePagination() {
    this.$el.querySelector('.slider__pagination__current-page').innerHTML = this.lory.returnIndex() + 1;
    this.$el.querySelector('.slider__pagination__total-page-count').innerHTML = this.$slides.length;
  }
}

document.querySelectorAll('.slider').forEach($slider => new Slider($slider));
